export const uniqueId = (length = 6, radix = 16) => {
    return (Math.random().toString(radix).substring(2)
        + (new Date()).getTime().toString(radix)).substr(0, length);
};